// @flow

// React Query cache keys for the V2 documentation server state. Keeping them in
// one place lets mutations invalidate lists/details without stringly-typed keys.
export const sessionDocumentKeys = {
  all: ['sessionDocuments'],
  lists: (): Array<mixed> => [...sessionDocumentKeys.all, 'list'],
  list: (params: {[string]: mixed}): Array<mixed> => [
    ...sessionDocumentKeys.lists(),
    params,
  ],
  details: (): Array<mixed> => [...sessionDocumentKeys.all, 'detail'],
  detail: (id: string): Array<mixed> => [...sessionDocumentKeys.details(), id],
  orgServiceTypes: ['orgServiceTypes'],
};
